export default "__VITE_ASSET__K8GmCa5l__"